import React, { useEffect, useState, useRef } from "react";
import { baseUrl } from '../../shared';
import '../../pages/App.css';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

function RepairPhotoProxy({ repairId, field }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    fetch(baseUrl + 'repair/photo/' + repairId + '/' + field, {
      headers: {
        username: localStorage.getItem('username'),
        bToken: localStorage.getItem('bToken'),
      },
    })
      .then(r => r.blob())
      .then(blob => setSrc(URL.createObjectURL(blob)));
  }, [repairId, field]);

  return src ? <img src={src} alt={field} width="150" /> : <span>Loading photo...</span>;
}

function RepairView({ assetId, repairId }) {
  const [repair, setRepair] = useState(null);
  const [notes, setNotes] = useState([]);
  const [repairCost, setRepairCost] = useState(null);

  useEffect(() => {
    const url = baseUrl + 'repair/asset-repair/' +repairId;
    const urlNotes = baseUrl + 'repair/asset-repair/' +repairId+'/notes';
    fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage?.getItem('username'),
            'bToken': localStorage?.getItem('bToken')
        }})
      .then((res) => res.json())
      .then((data) => setRepair(data));

    fetch(urlNotes, {
        method: 'GET',
        headers: {
            'username': localStorage?.getItem('username'),
            'bToken': localStorage?.getItem('bToken')
        }})
      .then((res) => res.json())
      .then((data) => setNotes(data));
  }, [repairId]);

  useEffect(() => {
    const repairCosting = baseUrl + 'repair/asset-costing/' +assetId;
    fetch(repairCosting, {
        method: 'GET',
        headers: {
            'username': localStorage?.getItem('username'),
            'bToken': localStorage?.getItem('bToken')
        }})
      .then((res) => res.json())
      .then((data) => setRepairCost(data));
  }, [assetId]);

  if (!repair) return <p>Loading...</p>;

  return (
    <div style={{ padding: "1rem" }}>
      {/* Status Timeline */}
{repair?.statusHistory && repair?.statusHistory.length > 0 && (() => {
  // Extract and normalize statuses
  const statuses = repair.statusHistory.map((entry) =>
    typeof entry === "string" ? entry : entry.status
  ).filter(Boolean);

  // Deduplicate consecutive duplicates
  const timeline = statuses.filter(
    (status, idx) => idx === 0 || status !== statuses[idx - 1]
  );

  return (
    <div style={{ display: "flex", alignItems: "center", margin: "1rem 0" }}>
      <div
  style={{
    display: "flex",
    flexWrap: "wrap", // ✅ allow wrapping
    alignItems: "center",
    gap: "8px",       // spacing instead of hardcoded margins
    margin: "1rem 0",
  }}
>
  {timeline.map((status, i) => (
    <div
      key={i}
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "8px", // spacing between wrapped rows
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          background: status === repair?.status ? "var(--primary)" : "var(--border-strong)",
          marginRight: 8,
        }}
      />
      <span
        style={{
          fontWeight: status === repair?.status ? "bold" : "normal",
          whiteSpace: "nowrap", // ✅ keep text with circle
        }}
      >
        {status === repair?.status ? `[${status}]` : status}
      </span>
      {i < timeline.length - 1 && (
        <div
          style={{
            width: 40,
            height: 2,
            background: "var(--border)",
            margin: "0 8px",
            flexShrink: 0, // ✅ prevents shrinking on wrap
          }}
        />
      )}
    </div>
  ))}
</div>

    </div>
  );
})()}

      <Typography variant="h6" sx={{ fontWeight: 700, color: 'var(--text)' }}>Repair/C&D #{repair?.repairId}</Typography>
      <p>
        <b>Asset:</b> {repair?.assetId}
      </p>
      <p>
        <b>Status:</b> {repair?.status}
      </p>
      <p>
        <b>Pickup Approved By:</b> {repair?.pickupApprovedBy}
      </p>
      <p>
        <b>Job Card:</b> {repair?.jobCard}
      </p>
      <p>
        <b>Purchase Order:</b> {repair?.purchaseOrder}
      </p>
      <p>
        <b>Line Item:</b> {repair?.lineItem}
      </p>
      {repair?.pickupPhotoUrl
        ? <RepairPhotoProxy repairId={repair.repairId} field="pickupPhoto" />
        : repair?.pickupPhoto
          ? <img src={repair.pickupPhoto} alt="Photo" width="150" />
          : null}
      {repair?.pickupSignature && <img src={repair.pickupSignature} alt="Pickup Signature" width="150" />}

        <p>
          <b>Return Approved By:</b> {repair?.returnApprovedBy}
        </p>
      {repair?.returnPhotoUrl
        ? <RepairPhotoProxy repairId={repair.repairId} field="returnPhoto" />
        : repair?.returnPhoto
          ? <img src={repair.returnPhoto} alt="Photo" width="150" />
          : null}
      {repair?.returnSignature && <img src={repair.returnSignature} alt="Return Signature" width="150" />}
    
      <br/>
      <br/>
      {/* Notes */}
      <div>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'var(--text)', mt: 1 }}>Notes</Typography>
        <br/>
        {notes?.length === 0 ? (
          <p>No notes yet.</p>
        ) : (
          <ul>
            {notes?.map((n) => (
              <li style={{'list-style-type': 'none', width: '100%'}} key={n?.noteId}><TextField style={{width: '100%'}} value={n?.noteText} multiline/></li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default RepairView;
